import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { tagListReducer } from "./reducers/tagReducers";
import {
  userLoginReducer,
  userDeleteReducer,
  userRegisterReducer,
  updateUserDetailsReducer,
  listSponsorsReducer,
  userDetailsReducer,
} from "./reducers/userReducers";

import {
  patientListReducer,
  newPatientReducer,
  patientDetailsReducer,
  patientUpdateReducer,
  PatientDeletedReducer,
} from "./reducers/patientReducers";

import {
  drugsReducer,
  listDrugRootsReducer,
  newDrugReducer,
  rootByTradeIdReducer,
  updateRootReducer,
} from "./reducers/drugReducers";

import { recaptchaConstantReducer } from "./reducers/recaptchaReducer";
import {
  clinicDetailsReducer,
  clinicUpdateReducer,
  newClinicReducer,
  userClinicsReducer,
} from "./reducers/clinicReducers";
import {
  clinicVisitReducer,
  newVisitReducer,
  patientVisitReducer,
  visitScanUpdateReducer,
} from "./reducers/visitReducer";

const reducer = combineReducers({
  drugRootsStore: listDrugRootsReducer,
  tradeLabelsStore: drugsReducer,

  newDrugStore: newDrugReducer,
  rootByTradeIdStore: rootByTradeIdReducer,
  updateRootStore: updateRootReducer,

  registeredUser: userRegisterReducer,
  updatedUserDetails: updateUserDetailsReducer,

  patientListStore: patientListReducer,
  patientDetails: patientDetailsReducer,
  patientAdditionStore: newPatientReducer,
  patientUpdateStore: patientUpdateReducer,
  patientDeleteStore: PatientDeletedReducer,
  tagListStore: tagListReducer,

  userDetails: userDetailsReducer,
  userLogin: userLoginReducer,
  userDelete: userDeleteReducer,
  sponsorsStore: listSponsorsReducer,

  clinicAddStore: newClinicReducer,
  clinicDetails: clinicDetailsReducer,
  clinicUpdateStore: clinicUpdateReducer,
  clinicsOfUserStore: userClinicsReducer,

  visitAddStore: newVisitReducer,
  visitsOfPatientStore: patientVisitReducer,
  visitsOfClinicStore: clinicVisitReducer,
  visitScanUpdateStore: visitScanUpdateReducer,

  recaptchaConstantStore: recaptchaConstantReducer,
});

const userInfoFromStorage = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : null;

const initialState = {
  userLogin: {
    userInfo: userInfoFromStorage,
  },
};

const middleware = [thunk];

const store =
  process.env.NODE_ENV === "production"
    ? createStore(reducer, initialState, applyMiddleware(...middleware))
    : createStore(
        reducer,
        initialState,
        composeWithDevTools(applyMiddleware(...middleware)),
      );

export default store;
